export class AccAcknowledgementResultDto {
  acknowledgement: string;
}
